export const CRF_LOGS_ENDPOINT = '/api/crfLogs'
export const WTAX_RATES_ENDPOINT = '/spreadsheet/wTaxRate'
export const DEPARTMENT_ENDPOINT = '/spreadsheet/department'
export const VENDOR_ENDPOINT = '/spreadsheet/vendor'
export const PROJECT_ENDPOINT = '/spreadsheet/project'
export const UPLOADS_ENDPOINT = '/api/uploads'

export const USER_INFO_ENDPOINT = '/api/userInfo'
export const CRF_CREATION_ENDPOINT = '/api/checkRequestForm'
